'use client'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'

export default function FormSelectInput({
  control,
  name,
  options,
  emptyOption = null,
  placeholder,
  labelPrefix = '',
  btnClassName,
  btnEndText,
  className,
  label,
  description,
  disabled,
}) {
  const allOptions = emptyOption ? [emptyOption].concat(options) : options
  return (
    <FormField
      name={name}
      control={control}
      render={({ field }) => (
        <FormItem className={cn('flex flex-col items-start', className)}>
          {label && <FormLabel>{label}</FormLabel>}

          {description && (
            <FormDescription className="mt-1!">{description}</FormDescription>
          )}

          <DropdownMenu modal={false}>
            <div className="flex w-full flex-wrap items-center gap-2">
              <DropdownMenuTrigger asChild>
                <Button
                  type="button"
                  variant="outline"
                  className={btnClassName}
                  disabled={disabled}
                >
                  <div className="flex items-center gap-2">
                    {labelPrefix}
                    {allOptions.find((o) => o?.value === field.value)?.label ||
                      placeholder}
                  </div>

                  <ChevronDown className="ml-2 h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>

              {btnEndText}
            </div>

            <FormControl>
              <DropdownMenuContent
                className="max-h-[300px] min-w-[200px] overflow-y-auto"
                align="center"
              >
                {options.length > 0
                  ? options.map((option) => (
                      <DropdownMenuItem
                        key={option.value}
                        className="cursor-pointer"
                        disabled={option.disabled}
                        onClick={() => field.onChange(option.value)}
                      >
                        {option.label}
                      </DropdownMenuItem>
                    ))
                  : emptyOption && (
                      <DropdownMenuItem
                        className="cursor-pointer"
                        disabled={emptyOption.disabled}
                        onClick={() => field.onChange(emptyOption.value)}
                      >
                        {emptyOption.label}
                      </DropdownMenuItem>
                    )}
              </DropdownMenuContent>
            </FormControl>
          </DropdownMenu>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
